import {ModuleConfiguration} from "../router/model/UserPermission";
import {SchedulingServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const SchedulingServiceModule = new ModuleConfiguration(
    SchedulingServiceModuleName, [
        AngularJsMaterialModuleName
    ]);